const TrainingTypes = [
    { id: 0, value: 'Attach Course', name: 'courses' },
    { id: 1, value: 'Attach Track', name: 'tracks' },
];
const DocumentTypes = [
    { id: 0, value: 'Attach Power Point', name: 'powerpoint' },
    { id: 1, value: 'Attach Word', name: 'word' },
    { id: 2, value: 'Attach PDF', name: 'pdf' },
];

const Expirations = [
    { id: 0, name: 'Never' },
    { id: 1, name: '6 months' },
    { id: 2, name: '12 months' },
    { id: 3, name: '24 months' },
    { id: 4, name: '36 months' },
];

export { TrainingTypes, DocumentTypes, Expirations };
